import { render, staticRenderFns } from "./NewPartnerUserModal.vue?vue&type=template&id=d2d2a54c&lang=pug&"
import script from "./NewPartnerUserModal.vue?vue&type=script&lang=js&"
export * from "./NewPartnerUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports